import styled from 'styled-components'
import { Title } from '../../assets/styles/commonStyles'
import { AccordionComponent } from '../../components'
import { CartContext } from '../../context/CartContext'
import { useContext } from 'react'
import { useEffect } from 'react'

const Container = styled.div`
  @media screen and (max-width:768px){
    margin-top: 40px;
  }
`
const Resources = () => {
  const {setCart} = useContext(CartContext)
  useEffect(()=>{
    // get the cart items from the localstorage
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    setCart(cartItems)
    // eslint-disable-next-line
  },[])
  return (
    <Container className={`animated slideInUp`}>
      <Title>RESOURCES</Title>
      <AccordionComponent />
    </Container>
  )
}

export default Resources